<template>
    <v-dialog v-model="abrir" persistent max-width="70vw" scrollable>
        <v-container>
        <v-card max-height="600px" :loading="loading">
            <v-toolbar flat :color="this.$store.state.title == 'Calendario' ? this.$store.state.corEvento : cor"></v-toolbar>
            <v-card-text>
            
                <v-data-table fixed-header :items="titulos" :headers="fields" :items-per-page="10">
                </v-data-table>
            
            </v-card-text>
            <v-divider>
            </v-divider>
            <v-card-actions>
                <v-spacer>
                </v-spacer>
                <v-btn small color="primary" @click.stop="fechar()">Fechar</v-btn>
            </v-card-actions>
        </v-card>
        </v-container>
    </v-dialog>
</template>

<script>
    
    //import Br from '@/config/barramento'
    import { baseApiUrl, showError } from "@/config/global"
    import axios from 'axios'

	export default{
        name: "Titulos",
        props: ['abrir', 'iniciado'],

		data(){
			return {
                loading: false,
                cor: 'primary',
                titulos: [],
				fields: [
					{text: 'Titulo', value: 'nome', align: 'center', divider: true},
					{text: 'Descrição', value: 'descricao', align: 'center', divider: true},
					{text: 'Data', value: 'data', align: 'center', divider: true},
				],
			}
		},

		methods:{

			buscaTitulos(id){
                
				const url = `${baseApiUrl}/perfil/buscaTitulos.php?iniciado=${id}`

				axios.post(url, this.iniciado)
				.then(res => {
					if(res.data.codigo == '01'){
                        this.titulos = res.data.titulos
					}else{
                        showError(res.data.mensagem)
                    }
                })
                
                this.loading = false
            },
            
            fechar(){
                this.$emit('fechar')
            },
            
		},

        watch:{
            abrir(val){
                if(val){
                    if(this.titulos.length == 0){
                        this.buscaTitulos(this.iniciado)
                    }
                }
            }
        }
	}
</script>

<style scoped>


</style>